/**
 * PDP m²-beregner: quantity-entry UI, DOM-opdateringer, delegerer matematik til HFCProductDomain.
 * Kræver `product-pdp-orderability-ui.js` (getOrderability m.m.) og `product-storefront-domain.js`.
 */
(function (global) {
    'use strict';

    var Ob = function () {
        return global.HFCProductPdpOrderabilityUi;
    };

    function getCurrentVariant() {
        var V = global.HFCProductPdpVariants;
        return V && typeof V.getCurrentVariant === 'function' ? V.getCurrentVariant() : null;
    }

    function getOrderability(variant) {
        var o = Ob();
        return o && typeof o.getOrderability === 'function' ? o.getOrderability(variant) : null;
    }

    function hasProductDomainOrderability() {
        var d = global.HFCProductDomain;
        return !!(d && typeof d.deriveOrderabilityView === 'function');
    }

    function isTrackedShopifyInventory(variant) {
        return String((variant && variant.inventory_management) || '') === 'shopify';
    }

    function domShow(el) {
        var o = Ob();
        if (o && typeof o.domShow === 'function') {
            o.domShow(el);
        }
    }

    function domHide(el) {
        var o = Ob();
        if (o && typeof o.domHide === 'function') {
            o.domHide(el);
        }
    }

    function syncBackorderBlockVisibility(variant, ob, qtyInput) {
        var o = Ob();
        if (o && typeof o.syncBackorderBlockVisibility === 'function') {
            o.syncBackorderBlockVisibility(variant, ob, qtyInput);
        }
    }

    function toggle_disable_order_sample_button(is_ordering_allowed) {
        var order_sample_btn = document.querySelector('#order_sample_button');
        if (!order_sample_btn) {
            return;
        }
        if (is_ordering_allowed) {
            order_sample_btn.removeAttribute('disabled');
        } else {
            order_sample_btn.setAttribute('disabled', '');
        }
    }

    function toggle_order_sample_button_visibility(product) {
        var is_sample_orderable = !!(product && product.is_sample_orderable);
        var sample_block = document.querySelector('.pdp-figma-sample-block');
        if (sample_block) {
            sample_block.hidden = !is_sample_orderable;
            sample_block.style.display = is_sample_orderable ? '' : 'none';
            return;
        }
        var btn = document.querySelector('#order_sample_button');
        if (!btn) {
            return;
        }
        if (is_sample_orderable) {
            btn.style.removeProperty('display');
        } else {
            btn.style.display = 'none';
        }
    }

    function ensure_order_sample_button_state() {
        try {
            var product = global.shopify_product || {};
            toggle_disable_order_sample_button(!!product.is_sample_orderable);
            toggle_order_sample_button_visibility(product);
        } catch (e) { /* noop */ }
    }

    function get_price_per_square_meter(price_per_square_meter, price_per_square_meter_discount) {
        var ui = global.HFCProductPdpPricingUi;
        if (ui && typeof ui.getPricePerSquareMeterHtml === 'function') {
            return ui.getPricePerSquareMeterHtml(price_per_square_meter, price_per_square_meter_discount, {
                presentation: document.querySelector('#m2_price_calculator.pdp-figma-m2-root') ? 'figma-m2' : 'legacy',
            });
        }
        return '';
    }

    function display_price_per_square_meter(price_per_square_meter, price_per_square_meter_discount_price) {
        var ui = global.HFCProductPdpPricingUi;
        if (ui && typeof ui.displayM2CalculatorPricePerSquareMeter === 'function') {
            ui.displayM2CalculatorPricePerSquareMeter(price_per_square_meter, price_per_square_meter_discount_price);
        }
    }

    function set_inner_html(element, value, options) {
        element.innerHTML = options ? value.toLocaleString('da-DK', options) : value;
    }

    function process_span_array(spanArray, value, options) {
        spanArray.forEach(function (span) {
            set_inner_html(span, value, options);
        });
    }

    function is_variant_context(candidate) {
        return !!(candidate && candidate.id != null && candidate.metafields);
    }

    function resolve_context_variant(context_variant) {
        if (is_variant_context(context_variant)) {
            return context_variant;
        }
        var V = global.HFCProductPdpVariants;
        if (V && typeof V.resolveSelectedVariant === 'function') {
            return V.resolveSelectedVariant();
        }
        return getCurrentVariant();
    }

    function get_calculator_elements(context_variant) {
        var v = resolve_context_variant(context_variant);
        return {
            variant: v,
            square_meter_input: document.querySelector('#m2_price_calculator #m2_input_square_meters'),
            waste_input: document.querySelector('#m2_price_calculator #m2_checkbox_waste'),
            waste_hint_el: document.querySelector('#m2_price_calculator #m2_waste_hint'),
            total_price_span: document.querySelector('#m2_price_calculator #m2_calculator_total_price_span'),
            total_packs_span: document.querySelector('#m2_price_calculator #total_packs_span'),
            if_m2_exceeds_span: document.querySelector('#m2_price_calculator #if_m2_exceeds_span'),
            if_m2_exceeds_red_color: document.querySelector('#m2_price_calculator #if_m2_exceeds_show_red_color'),
            total_square_meters_span: document.querySelector('#m2_price_calculator #total_square_meters_span'),
            total_packs_inventory_span: document.querySelector('#m2_price_calculator #total_packs_inventory_span'),
            buy_buttons_quantity_input: document.querySelector('input[data-quantity-input]'),
            not_same_batch_message_div: document.querySelector('#m2_price_calculator #not_same_batch_message_div'),
            m2_exceeds_message_div: document.querySelector('#m2_price_calculator #m2_exceeds_message_div'),
            m2_out_of_stock_div: document.querySelector('#m2_price_calculator #m2_out_of_stock_div'),
            status_on_stock_div: document.querySelector('#m2_price_calculator #status_on_stock_div'),
            status_available_on_stock_div: document.querySelector('#m2_price_calculator #status_available_on_stock_div'),
            status_not_on_stock_div: document.querySelector('#m2_price_calculator #status_not_on_stock_div'),
            package_span: document.querySelector('#m2_price_calculator .js-m2-package-label'),
            order_sample_button: document.querySelector('#order_sample_button'),
        };
    }

    function get_square_meters(square_meter_input, waste_input) {
        var d = global.HFCProductDomain;
        if (d && typeof d.applyM2WasteToSquareMeters === 'function' && square_meter_input) {
            return d.applyM2WasteToSquareMeters(square_meter_input.value, !!(waste_input && waste_input.checked));
        }
        var square_meters = parseFloat(square_meter_input && square_meter_input.value, 10) || 0;
        if (waste_input && waste_input.checked) {
            square_meters *= 1.1;
        }
        return square_meters;
    }

    function calculate_packs(square_meters, metafields) {
        var d = global.HFCProductDomain;
        if (d && typeof d.calculatePacksCeilFromM2Metafields === 'function') {
            return d.calculatePacksCeilFromM2Metafields(square_meters, metafields);
        }
        var pieces_per_square_meter = metafields.pieces_per_square_meter;
        var pieces_per_pack = metafields.pieces_per_pack;
        var total_pieces_needed = square_meters * pieces_per_square_meter;
        return Math.max(Math.ceil(total_pieces_needed / pieces_per_pack), 1);
    }

    function display_packs(packs, calculator) {
        var variant = calculator.variant;
        var invHtml;
        if (variant && calculator.total_packs_inventory_span) {
            if (hasProductDomainOrderability()) {
                var obInv = getOrderability(variant);
                var fsInv = obInv && obInv.fulfillment_state;
                if (fsInv === 'in_stock' && !isTrackedShopifyInventory(variant)) {
                    var q = parseInt(variant.inventory_quantity, 10);
                    if (!Number.isFinite(q)) {
                        q = parseFloat(variant.total_packs, 10) || 0;
                    }
                    if (!q) {
                        invHtml = '\u2013';
                    } else {
                        invHtml = String(variant.total_packs);
                    }
                } else {
                    invHtml = variant.total_packs;
                }
            } else {
                invHtml = variant.total_packs;
            }
            calculator.total_packs_inventory_span.innerHTML = invHtml;
        }
        var figmaPdp = !!document.querySelector('.product-template.pdp-figma-styles');
        var plural = packs > 1;
        var word = figmaPdp
            ? (plural ? 'kasser' : 'kasse')
            : (plural ? 'pakker' : 'pakke');
        document.querySelectorAll('#m2_price_calculator .js-m2-package-label').forEach(function (el) {
            el.textContent = word;
        });
        if (calculator.package_span) {
            calculator.package_span.textContent = word;
        }
        if (calculator.total_packs_span) {
            calculator.total_packs_span.innerHTML = packs;
        }
        if (calculator.buy_buttons_quantity_input) {
            calculator.buy_buttons_quantity_input.value = packs;
        }
    }

    function display_square_meters(packs, metafields, calculator) {
        var total_square_meters = (packs * metafields.per_pack_square_meter).toFixed(2);
        var formatter = new Intl.NumberFormat('da-DK');
        calculator.total_square_meters_span.innerHTML = formatter.format(total_square_meters);
    }

    function display_total_price(packs, variables, calculator) {
        var pack_price = variables.per_pack_sales_price != null && variables.per_pack_sales_price !== 0
            ? variables.per_pack_sales_price
            : variables.per_pack_price;
        var total_price = (packs * pack_price).toLocaleString('da-DK', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        });
        calculator.total_price_span.innerHTML = total_price;
    }

    function display_waste_hint(effective_square_meters, waste_checked, calculator) {
        var hint_el = calculator && calculator.waste_hint_el;
        if (!hint_el) {
            return;
        }
        if (waste_checked && Number.isFinite(effective_square_meters) && effective_square_meters > 0) {
            var formatter = new Intl.NumberFormat('da-DK', {
                minimumFractionDigits: 1,
                maximumFractionDigits: 2,
            });
            hint_el.textContent = 'Beregner med ' + formatter.format(effective_square_meters) + ' m\u00B2 (inkl. 10% spild)';
            hint_el.hidden = false;
            hint_el.classList.remove('hidden');
        } else {
            hint_el.textContent = '';
            hint_el.hidden = true;
            hint_el.classList.add('hidden');
        }
    }

    function display_batch_message(square_meters, biggest_batch_size, not_same_batch_message_div) {
        not_same_batch_message_div.style.display = biggest_batch_size < square_meters ? 'block' : 'none';
    }

    function display_exceeds_message(packs, metafields, calculator) {
        if (!calculator || !metafields || !calculator.if_m2_exceeds_span || !calculator.if_m2_exceeds_red_color) {
            return;
        }
        var d = global.HFCProductDomain;
        var variant = calculator && calculator.variant;
        var total_square_meters = d && typeof d.totalOrderedSquareMetersFromPacks === 'function'
            ? d.totalOrderedSquareMetersFromPacks(packs, metafields)
            : packs * metafields.per_pack_square_meter;
        var obEx = variant ? getOrderability(variant) : null;
        var fs = obEx && obEx.fulfillment_state ? obEx.fulfillment_state : null;
        var cap = metafields.total_square_meter_quantity;
        var blocked = d && fs ? d.shouldBlockM2TotalSquareMeters(fs, total_square_meters, cap) : (
            total_square_meters > cap && cap !== 0
        );
        var showMsg = d && fs && typeof d.shouldShowM2ExceedUserMessage === 'function'
            ? d.shouldShowM2ExceedUserMessage(fs, total_square_meters, cap, {
                requirePositiveTotalStockMetafield: true,
                totalStockMetafield: metafields.total_stock,
            })
            : (blocked && cap !== 0);
        calculator.if_m2_exceeds_span.style.color = blocked ? 'red' : 'black';
        calculator.if_m2_exceeds_red_color.style.color = blocked ? 'red' : 'black';
        calculator.if_m2_exceeds_red_color.style.fontWeight = blocked ? 'bold' : 'normal';
        if (showMsg) {
            domShow(calculator.m2_exceeds_message_div);
        } else {
            domHide(calculator.m2_exceeds_message_div);
        }
    }

    function display_stock_message_legacy_total_packs(variant, calculator) {
        if (variant.total_packs == 0) {
            if (variant.metafields && variant.metafields.is_procured) {
                domShow(calculator.status_available_on_stock_div);
                domHide(calculator.status_on_stock_div);
            } else {
                domShow(calculator.m2_out_of_stock_div);
                domHide(calculator.status_on_stock_div);
                domHide(calculator.status_available_on_stock_div);
                domShow(calculator.status_not_on_stock_div);
            }
        } else {
            domHide(calculator.m2_out_of_stock_div);
            domShow(calculator.status_on_stock_div);
            domHide(calculator.status_not_on_stock_div);
            domHide(calculator.status_available_on_stock_div);
        }
    }

    function display_stock_message(variant, calculator) {
        if (!variant || !calculator) {
            return;
        }
        if (!hasProductDomainOrderability()) {
            display_stock_message_legacy_total_packs(variant, calculator);
            return;
        }
        var ob = getOrderability(variant);
        if (!ob || !ob.fulfillment_state) {
            display_stock_message_legacy_total_packs(variant, calculator);
            return;
        }
        var fs = ob.fulfillment_state;
        if (fs === 'out_of_stock_non_backorderable') {
            domShow(calculator.m2_out_of_stock_div);
            domHide(calculator.status_on_stock_div);
            domHide(calculator.status_available_on_stock_div);
            domShow(calculator.status_not_on_stock_div);
            return;
        }
        if (fs === 'special_order') {
            var branch = ob.special_order_inventory_branch;
            if (branch === 'in_stock') {
                domHide(calculator.m2_out_of_stock_div);
                domShow(calculator.status_on_stock_div);
                domHide(calculator.status_not_on_stock_div);
                domHide(calculator.status_available_on_stock_div);
            } else {
                domHide(calculator.m2_out_of_stock_div);
                domShow(calculator.status_available_on_stock_div);
                domHide(calculator.status_on_stock_div);
                domHide(calculator.status_not_on_stock_div);
            }
            return;
        }
        domHide(calculator.m2_out_of_stock_div);
        domShow(calculator.status_on_stock_div);
        domHide(calculator.status_not_on_stock_div);
        domHide(calculator.status_available_on_stock_div);
    }

    function render_calculation(context_variant) {
        var m2_price_calculator = get_calculator_elements(context_variant);
        var variant = m2_price_calculator.variant;
        if (!variant || !variant.metafields) {
            return;
        }
        var dQty = global.HFCProductDomain;
        var packs;
        var square_meters;
        if (dQty && typeof dQty.deriveM2QuantitySnapshot === 'function' && m2_price_calculator.square_meter_input && m2_price_calculator.waste_input) {
            var snap = dQty.deriveM2QuantitySnapshot(
                variant,
                m2_price_calculator.square_meter_input.value,
                m2_price_calculator.waste_input.checked,
                'ceil'
            );
            packs = snap.packs;
            square_meters = snap.effective_square_meters;
        } else {
            square_meters = get_square_meters(m2_price_calculator.square_meter_input, m2_price_calculator.waste_input);
            packs = calculate_packs(square_meters, variant.metafields);
        }
        display_price_per_square_meter(variant.metafields.price_per_square_meter, variant.metafields.per_m2_discount_price);
        display_packs(packs, m2_price_calculator);
        display_square_meters(packs, variant.metafields, m2_price_calculator);
        display_total_price(packs, variant, m2_price_calculator);
        display_batch_message(square_meters, variant.metafields.biggest_batch_size, m2_price_calculator.not_same_batch_message_div);
        display_waste_hint(
            square_meters,
            !!(m2_price_calculator.waste_input && m2_price_calculator.waste_input.checked),
            m2_price_calculator
        );
        if (variant && variant.metafields && m2_price_calculator.m2_exceeds_message_div) {
            display_exceeds_message(packs, variant.metafields, m2_price_calculator);
        }
        display_stock_message(variant, m2_price_calculator);
    }

    function on_quantity_input_change(input_value, context_variant) {
        var variant = resolve_context_variant(context_variant);
        if (!variant || !variant.metafields) {
            return;
        }
        var m2_price_calculator = get_calculator_elements(variant);
        var dQty = global.HFCProductDomain;
        var packs;
        var totalM2;
        if (dQty && typeof dQty.deriveM2QuantitySnapshot === 'function' && m2_price_calculator.square_meter_input && m2_price_calculator.waste_input) {
            var snap2 = dQty.deriveM2QuantitySnapshot(
                variant,
                m2_price_calculator.square_meter_input.value,
                m2_price_calculator.waste_input.checked,
                'ceil'
            );
            packs = snap2.packs;
            totalM2 = snap2.total_ordered_square_meters;
        } else {
            var square_meters = get_square_meters(m2_price_calculator.square_meter_input, m2_price_calculator.waste_input);
            packs = calculate_packs(square_meters, variant.metafields);
            totalM2 = packs * (variant.metafields && variant.metafields.per_pack_square_meter ? parseFloat(variant.metafields.per_pack_square_meter, 10) : 0);
        }
        if (parseInt(input_value, 10) === 0) {
            input_value = 1;
        }
        syncBackorderBlockVisibility(variant, getOrderability(variant), input_value);
        var d = global.HFCProductDomain;
        var obQty = getOrderability(variant);
        var fs = obQty && obQty.fulfillment_state ? obQty.fulfillment_state : null;
        var cap = variant.metafields && variant.metafields.total_square_meter_quantity;
        if (d && fs && m2_price_calculator.m2_exceeds_message_div && d.shouldShowM2ExceedUserMessage(fs, totalM2, cap, {
            requirePositiveTotalStockMetafield: true,
            totalStockMetafield: variant.metafields && variant.metafields.total_stock,
        })) {
            display_exceeds_message(packs, variant.metafields, m2_price_calculator);
        } else if (m2_price_calculator.m2_exceeds_message_div) {
            m2_price_calculator.m2_exceeds_message_div.style.display = 'none';
        }
    }

    function update_quantity_info(context_variant) {
        var calc_quantity_value = document.querySelector('#total_packs_span');
        var quantity_input = document.querySelector('.quantity-input__element');
        if (calc_quantity_value != null) {
            on_quantity_input_change(calc_quantity_value.innerHTML, context_variant);
        } else if (quantity_input != null) {
            on_quantity_input_change(quantity_input.value, context_variant);
        }
    }

    var last_variant_picker_m2_mode = null;

    function reinit_size_pill_swatches() {
        document.querySelectorAll('variant-picker').forEach(function (vp) {
            if (vp && typeof vp.initOptionSwatches === 'function') {
                vp.initOptionSwatches();
            }
        });
    }

    function after_variant_picker_refresh(current_variant, variants) {
        var sale_ui = global.HFCProductPdpVariantSaleUi;
        if (sale_ui && typeof sale_ui.applyVariantOptionSaleToDom === 'function') {
            sale_ui.applyVariantOptionSaleToDom(current_variant);
        }
        var ob = global.HFCProductPdpOrderabilityUi;
        if (ob && typeof ob.updatePlinthSwatch === 'function') {
            ob.updatePlinthSwatch(variants, current_variant);
        }
        reinit_size_pill_swatches();
    }

    function refresh_variant_picker_if_mode_changed(current_variant, uses_m2, variants) {
        var variant_picker_wrap = document.querySelector('.product__variant-picker');
        var section_el = document.querySelector('.product-template') && document.querySelector('.product-template').closest('[id^="shopify-section-"]');
        if (!variant_picker_wrap || !section_el) {
            return;
        }
        var section_id = section_el.id.replace('shopify-section-', '');
        var variant_id = current_variant && current_variant.id;
        var url = window.location.pathname + '?section_id=' + encodeURIComponent(section_id);
        if (variant_id) {
            url += '&variant=' + encodeURIComponent(variant_id);
        }
        fetch(url)
            .then(function (response) {
                return response.text();
            })
            .then(function (html) {
                var doc = new DOMParser().parseFromString(html, 'text/html');
                var new_picker = doc.querySelector('.product__variant-picker');
                if (!new_picker) {
                    return;
                }
                variant_picker_wrap.innerHTML = new_picker.innerHTML;
                after_variant_picker_refresh(current_variant, variants);
            })
            .catch(function () {});
    }

    function sync_figma_pdp_layout_mode(uses_m2) {
        var figma_pdp_root = document.querySelector('.product-template.pdp-figma-styles');
        if (!figma_pdp_root) {
            return;
        }
        if (uses_m2) {
            figma_pdp_root.classList.add('pdp-figma-uses-m2');
            figma_pdp_root.classList.remove('pdp-figma-standard-qty');
        } else {
            figma_pdp_root.classList.remove('pdp-figma-uses-m2');
            figma_pdp_root.classList.add('pdp-figma-standard-qty');
        }
    }

    function show_calculator_ui() {
        domShow(document.querySelector('#m2_price_calculator'));
        domHide(document.querySelector('.main-product__block.main-product__block-price'));
        domShow(document.querySelector('#_custom-delivered-in-x-qty'));
        domHide(document.querySelector('.quantity_and_buy_button_div .form__input-wrapper'));
    }

    function show_default_price_ui() {
        domShow(document.querySelector('.quantity_and_buy_button_div .form__input-wrapper'));
        domShow(document.querySelector('.main-product__block.main-product__block-price'));
        domHide(document.querySelector('#m2_price_calculator'));
        domHide(document.querySelector('#_custom-delivered-in-x-qty'));
    }

    function handle_calculator_mode(current_variant, variants) {
        if (!current_variant) {
            return;
        }
        var o = Ob();
        var usesM2 = o && typeof o.variantUsesM2Calculator === 'function' && o.variantUsesM2Calculator(current_variant);
        var previous_m2_mode = last_variant_picker_m2_mode;
        sync_figma_pdp_layout_mode(usesM2);
        last_variant_picker_m2_mode = usesM2;
        if (usesM2) {
            if (previous_m2_mode === null) {
                reinit_size_pill_swatches();
            }
            show_calculator_ui();
            startup_price_calculator(current_variant);
            change_product_details(current_variant);
            render_calculation(current_variant);
            update_quantity_info(current_variant);
        } else {
            show_default_price_ui();
        }
    }

    function bind_figma_m2_stepper(input) {
        var calculator_root = input.closest('#m2_price_calculator.pdp-figma-m2-root');
        if (!calculator_root || calculator_root.dataset.m2StepperBound) {
            return;
        }
        calculator_root.dataset.m2StepperBound = '1';
        calculator_root.addEventListener('click', function (event) {
            var button = event.target.closest('button[data-m2-step]');
            if (!button || !calculator_root.contains(button)) {
                return;
            }
            var direction = Number(button.dataset.m2Step);
            if (direction !== -1 && direction !== 1) {
                return;
            }
            var square_meter_input = calculator_root.querySelector('#m2_input_square_meters');
            if (!square_meter_input) {
                return;
            }
            var current_value = Number(square_meter_input.value);
            if (!Number.isFinite(current_value)) {
                current_value = 0;
            }
            var next_value = Math.max(0, Math.min(999, current_value + direction));
            square_meter_input.value = Number(next_value.toPrecision(15));
            square_meter_input.dispatchEvent(new Event('input', { bubbles: true }));
        });
    }

    function startup_price_calculator(context_variant) {
        var variant = resolve_context_variant(context_variant);
        if (!variant) {
            return;
        }
        var m2_calculator_square_meter_input = document.querySelector('#m2_price_calculator #m2_input_square_meters');
        var m2_calculator_waste_input = document.querySelector('#m2_price_calculator #m2_checkbox_waste');
        var product = global.shopify_product || {};
        toggle_disable_order_sample_button(!!product.is_sample_orderable);
        toggle_order_sample_button_visibility(product);
        set_initial_product_details(variant);
        if (m2_calculator_waste_input && !m2_calculator_waste_input.dataset.m2WasteBound) {
            m2_calculator_waste_input.dataset.m2WasteBound = '1';
            m2_calculator_waste_input.addEventListener('change', function () {
                render_calculation(resolve_context_variant());
            });
        }
        if (m2_calculator_square_meter_input && variant.metafields) {
            if (!m2_calculator_square_meter_input.dataset.m2SquareBound) {
                m2_calculator_square_meter_input.dataset.m2SquareBound = '1';
                m2_calculator_square_meter_input.addEventListener('input', sanitize_input);
            }
            bind_figma_m2_stepper(m2_calculator_square_meter_input);
            m2_calculator_square_meter_input.value = variant.metafields.per_pack_square_meter;
        }
    }

    function set_initial_product_details(variant) {
        if (!variant || !variant.metafields) {
            return;
        }
        var price_per_square_meter_span = document.querySelector('#m2_price_calculator #price_per_square_meter_span');
        var pieces_per_pack_span_array = document.querySelectorAll('#m2_price_calculator #pieces_per_pack_span');
        var per_pack_square_meter_span = document.querySelector('#m2_price_calculator #per_pack_square_meter_span');
        var per_pack_price_span = document.querySelector('#m2_price_calculator #per_pack_price_span');
        var total_stock_span = document.querySelector('#m2_price_calculator #total_stock_span');
        var total_square_meter_quantity_span_array = document.querySelectorAll('#m2_price_calculator #total_square_meter_quantity_span');
        var to_locale_string_options = {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        };
        set_inner_html(price_per_square_meter_span, get_price_per_square_meter(variant.metafields.price_per_square_meter, variant.metafields.per_m2_discount_price));
        process_span_array(pieces_per_pack_span_array, variant.metafields.pieces_per_pack);
        set_inner_html(per_pack_square_meter_span, variant.metafields.per_pack_square_meter, to_locale_string_options);
        var per_pack_price = variant.per_pack_sales_price != null && variant.per_pack_sales_price !== 0 ? variant.per_pack_sales_price : variant.per_pack_price;
        set_inner_html(per_pack_price_span, per_pack_price, to_locale_string_options);
        set_inner_html(total_stock_span, variant.metafields.total_stock);
        process_span_array(total_square_meter_quantity_span_array, variant.metafields.total_square_meter_quantity, to_locale_string_options);
    }

    function change_product_details(context_variant) {
        var variant = resolve_context_variant(context_variant);
        if (!variant || !variant.metafields) {
            return;
        }
        var price_per_square_meter_span = document.querySelector('#m2_price_calculator #price_per_square_meter_span');
        var pieces_per_pack_span_array = document.querySelectorAll('#m2_price_calculator #pieces_per_pack_span');
        var per_pack_square_meter_span = document.querySelector('#m2_price_calculator #per_pack_square_meter_span');
        var per_pack_price_span = document.querySelector('#m2_price_calculator #per_pack_price_span');
        var total_stock_span = document.querySelector('#m2_price_calculator #total_stock_span');
        var total_square_meter_quantity_span_array = document.querySelectorAll('#m2_price_calculator #total_square_meter_quantity_span');
        var m2_calculator_square_meter_input = document.querySelector('#m2_price_calculator #m2_input_square_meters');
        var to_locale_string_options = {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        };
        set_inner_html(price_per_square_meter_span, get_price_per_square_meter(variant.metafields.price_per_square_meter, variant.metafields.per_m2_discount_price));
        process_span_array(pieces_per_pack_span_array, variant.metafields.pieces_per_pack);
        set_inner_html(per_pack_square_meter_span, variant.metafields.per_pack_square_meter, to_locale_string_options);
        var per_pack_price = variant.per_pack_sales_price != null && variant.per_pack_sales_price !== 0 ? variant.per_pack_sales_price : variant.per_pack_price;
        set_inner_html(per_pack_price_span, per_pack_price, to_locale_string_options);
        if (total_stock_span) {
            total_stock_span.innerHTML = variant.metafields.total_stock;
        }
        process_span_array(total_square_meter_quantity_span_array, variant.metafields.total_square_meter_quantity, to_locale_string_options);
        if (m2_calculator_square_meter_input) {
            m2_calculator_square_meter_input.value = variant.metafields.per_pack_square_meter;
        }
    }

    function sanitize_input(event) {
        if (event.target.closest('#m2_price_calculator.pdp-figma-m2-root')) {
            var input_value = Number(event.target.value);
            if (Number.isFinite(input_value)) {
                var clamped_value = Math.max(0, Math.min(999, input_value));
                if (clamped_value !== input_value) {
                    event.target.value = clamped_value;
                }
            }
            render_calculation(resolve_context_variant());
            return;
        }
        var max_number = 999;
        var max_chars = 5;
        if (event.target.value < 0) {
            event.target.value = 0;
        } else if (event.target.value > max_number) {
            event.target.value = event.target.value.slice(0, 3);
        } else if (event.target.value.length > max_chars) {
            event.target.value = event.target.value.slice(0, max_chars);
        } else {
            render_calculation(resolve_context_variant());
        }
    }

    global.m2_price_calculator = global.m2_price_calculator || {};

    global.HFCProductPdpM2CalculatorUi = {
        handleCalculatorMode: handle_calculator_mode,
        showCalculatorUi: show_calculator_ui,
        showDefaultPriceUi: show_default_price_ui,
        onQuantityInputChange: on_quantity_input_change,
        startupPriceCalculator: startup_price_calculator,
        renderCalculation: render_calculation,
        changeProductDetails: change_product_details,
        getCalculatorElements: get_calculator_elements,
        updateQuantityInfo: update_quantity_info,
        ensureOrderSampleButtonState: ensure_order_sample_button_state,
        sanitizeInput: sanitize_input,
    };
})(typeof window !== 'undefined' ? window : this);
